import { useMutation, gql } from "@apollo/client"
import { ADMINABLE_USERS_FIELDS } from "./useQueryAdminableUsers"

const RESEND_INVITES_MUTATION = gql`
  ${ADMINABLE_USERS_FIELDS}
  mutation ResendInvites($ids: [ID!]!) {
    resendInvites(ids: $ids) {
      ...AdminableUsersFields
    }
  }
`

const useMutationResendInvites = () => useMutation(RESEND_INVITES_MUTATION)

export { useMutationResendInvites }
